import React from 'react';
import { useQuery } from '@apollo/client';
import Badge from '../components/Badge';
import InfiniteScrollWaypoint from '../components/InfiniteScrollWaypoint';
import SquarishCardGrid from '../components/SquarishCardGrid';
import UserSquarishCard from '../components/UserSquarishCard';
import { gql } from '../graphql/generated/gql';
import { UserType } from '../graphql/generated/graphql';
import ConnectionHelper from '../utils/graphql/ConnectionHelper';
import * as styles from './OrganizationUsers.module.scss';

const ITEM_HEIGHT = parseInt(styles.itemHeight, 10);

const PAGE_SIZE = 36;

const ORGANIZATION_USERS_QUERY = gql(/** @complexity 2 */ `
  query OrganizationUsersQuery($afterCursor: String, $pageSize: Int, $types: [UserType!]!) {
      listUsers(after: $afterCursor, first: $pageSize, types: $types) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            type
            ...UserSquarishCard_user
          }
        }
      }
  }
`);

const OrganizationUsers = () => {
  const response = useQuery(ORGANIZATION_USERS_QUERY, {
    variables: {
      types: [UserType.Admin, UserType.User, UserType.Guest],
      pageSize: PAGE_SIZE,
    },
  });

  const fetchMore = ConnectionHelper.generateFetchMore(
    ORGANIZATION_USERS_QUERY,
    response,
    'listUsers',
  );

  return (
    <>
      <SquarishCardGrid>
        {response.data?.listUsers?.edges?.map(
          (item) =>
            !!item?.node && (
              <SquarishCardGrid.Item key={item.node.id}>
                <UserSquarishCard
                  user={item.node}
                  badge={
                    item.node.type === UserType.Admin && (
                      <Badge color="blue">admin</Badge>
                    )
                  }
                  link
                />
              </SquarishCardGrid.Item>
            ),
        )}
      </SquarishCardGrid>
      <div className={styles.infiniteScrollWaypoint}>
        <InfiniteScrollWaypoint
          fetchMore={fetchMore}
          prefetchDistance={ITEM_HEIGHT * 6}
        />
      </div>
    </>
  );
};

export default OrganizationUsers;
